import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { LOCATION_CHANGE } from '~/redux-modules/dfm-layers/constants'

export const useRouterTrack = () => {
    const location = useLocation()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch({
            type: LOCATION_CHANGE,
            payload: {
                location,
            },
        })
    }, [location, dispatch])
}
